<template>
  <div id="app" class="container-sd">
    <!--<div class="container-fluid"> -->

        <Menu /><!-- se añade el menú -->
        <b-container fluid class="posicionAbajo">
        <!--  <b-breadcrumb :items="items"></b-breadcrumb> -->
        <router-view/>
        </b-container>
        <footer class="footer posicionPie" role="contentinfo"> 
           <Footer />
         </footer>
    <!--</div> -->
  </div>
</template>

<script>
import Menu from './components/Menu'
//import Switch from './components/Switch3'

import Footer from './components/Footer'

export default {
  name: 'App',
  components: {
    Menu,
    Footer
  },
  data() {
      return {
        items: [
          {
            text: 'Home',
            href: '/HomeNA',
            to:"/HomeNA"
          },
          {
            text: 'Página actual',
            active: true,
            pagina_accesible: true
          }
        ]
      }
    }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.posicionAbajo{
top:300px;
z-index: 1030;

}
.posicionPie {
bottom:-200px;
  width: 100%;
  /*z-index: 1030;*/
  position: relative;


}
.footer {
  margin-top: auto;
  display: table;
  width: 100%;
  height: 13vh;
  color:#fff;
  text-align: center;
}
</style>
